/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface BoundingBox2d
 */
export interface BoundingBox2d {
  /**
   *
   * @type {number}
   * @memberof BoundingBox2d
   */
  posX: number
  /**
   *
   * @type {number}
   * @memberof BoundingBox2d
   */
  posY: number
  /**
   *
   * @type {number}
   * @memberof BoundingBox2d
   */
  width: number
  /**
   *
   * @type {number}
   * @memberof BoundingBox2d
   */
  height: number
}

/**
 * Check if a given object implements the BoundingBox2d interface.
 */
export function instanceOfBoundingBox2d(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'posX' in value
  isInstance = isInstance && 'posY' in value
  isInstance = isInstance && 'width' in value
  isInstance = isInstance && 'height' in value

  return isInstance
}

export function BoundingBox2dFromJSON(json: any): BoundingBox2d {
  return BoundingBox2dFromJSONTyped(json, false)
}

export function BoundingBox2dFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BoundingBox2d {
  if (json === undefined || json === null) {
    return json
  }
  return {
    posX: json['posX'],
    posY: json['posY'],
    width: json['width'],
    height: json['height'],
  }
}

export function BoundingBox2dToJSON(value?: BoundingBox2d | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    posX: value.posX,
    posY: value.posY,
    width: value.width,
    height: value.height,
  }
}
